import React from 'react';
import { OverlayTrigger, Tooltip } from '@bingads-webui-react/primitive';
import { withOverflowProp } from '@bingads-webui-react/with-overflow-prop';

export const OverflowBreadcrumb = withOverflowProp(({
  text, isTextOverflow, forwardedRef, customClassName, tooltipPlacement = 'right', ...passThroughProps
}) => (
  <OverlayTrigger
    key={tooltipPlacement}
    placement={tooltipPlacement}
    overlay={
      <Tooltip
        id={tooltipPlacement}
        className={isTextOverflow ? '' : 'hide'}
      >
        {text}
      </Tooltip>
    }
  >
    <span ref={forwardedRef} className={customClassName} {...passThroughProps}>{text}</span>
  </OverlayTrigger>
));
